export const CENTERED_THRESHOLD = 0.0001;
export const PASTE_DELTA = 0.5;
export const PRODUCT_TRAY_HEIGHT = 100;
export const RECENT_UPLOADS_MAX = 9;
export const SANDWICH_BOTTOM_HEIGHT = 55;
export const STANDARD_PRODUCT_IMAGE_WIDTH = 513;
